[
 {
  "id": "share",
  "x": 145,
  "y": 1147,
  "w": 653,
  "h": 116
 }
]